import { FAQ as McFaq } from '@mc/faq'
import { useTranslation } from '@mc/i18n'
import { TrackingContainer } from '@mc/visibility'
import { trackPrcng1079EV } from 'experiments/prcng-1079_v1_remove_refund_copy'
import { type SectionsOptions, useFaqData } from './hooks/useFaqData'

// prcng-1079_v1 exposure. 0.3 rather than the 0.7 default because the FAQ block
// is routinely taller than a mobile viewport; 0.3 is the threshold `@mc/faq`
// already uses on this same element for its own FAQ Viewed event, so exposure
// counts should track that event 1:1. Module-scope so the object identity is
// stable across renders (TrackingContainer memoizes on it).
const PRCNG_1079_VISIBILITY_CONFIG = { threshold: 0.3 }

export const FAQ = ({
  eventType,
  eventLocation,
  pageSource = '',
  className = '',
  shouldShowLargeHeader = false,
  sections,
  title,
  ...props
}: {
  eventType: string
  eventLocation: string
  pageSource?: string
  className?: string
  shouldShowLargeHeader?: boolean
  sections?: SectionsOptions
  title?: string
  id?: string
}) => {
  const { t } = useTranslation('@mc/next')
  const { faqData } = useFaqData({ sections })
  // `useFaqData` defaults to ['general', 'pricing'] when `sections` is omitted.
  const hasPricingSection = !sections || sections.includes('pricing')

  return (
    <section
      {...props}
      className={`mc-py-10 ${className}`}
      data-testid='faq-section'
      id='faq'
    >
      <TrackingContainer
        config={PRCNG_1079_VISIBILITY_CONFIG}
        onFirstVisible={hasPricingSection ? trackPrcng1079EV : undefined}
      >
        <McFaq
          mainTitle={title || t('faq.title.string')}
          data={faqData}
          trackingProps={{
            name: eventType,
            location: eventLocation,
            pageSource,
          }}
          appearance={{ shouldShowLargeHeader }}
          {...props}
        />
      </TrackingContainer>
    </section>
  )
}
